import React, { useEffect, useRef, useState, useMemo } from "react";
import ForwardersContext, { getForwarderContextById } from "./ForwardersContext";
import { ForwardersActions } from "../stores/ForwardersStore";
const SingleForwarderProvider = ({ forwarderId, children }) => {
  const [forwarder, setForwarder] = useState();
  const [forwarderContext, setForwarderContext] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const fetchPromise = useRef();
  const timeout = useRef();
  const forwardersContextValue = useMemo(() => {
    const effectiveForwardersContext = forwarderContext || {};
    return {
      forwarders: forwarder ? [forwarder] : [],
      forwardersContext: forwarderContext || {},
      isLoading,
      getForwarderContext: getForwarderContextById(effectiveForwardersContext)
    };
  }, [forwarderContext, forwarder, isLoading]);
  useEffect(() => {
    const fetchForwarder = () => {
      if (fetchPromise.current) {
        return;
      }
      setIsLoading(true);
      fetchPromise.current = ForwardersActions.get(forwarderId).then((response) => {
        setForwarder(response.forwarder);
        setForwarderContext(response.forwarderContext);
        return response;
      }).finally(() => {
        fetchPromise.current = void 0;
        setIsLoading(false);
      });
    };
    fetchForwarder();
    timeout.current = window.setInterval(() => {
      fetchForwarder();
    }, 5e3);
    return () => {
      fetchPromise.current = void 0;
      setIsLoading(false);
      if (timeout.current) {
        clearInterval(timeout.current);
      }
    };
  }, [forwarderId]);
  return /* @__PURE__ */ React.createElement(ForwardersContext.Provider, { value: forwardersContextValue }, children);
};
export default SingleForwarderProvider;
